import React, { useRef, useEffect } from "react";
import { Toast } from "primereact/toast";
import "./style.scss";

const TemporaryNotification = ({ successMsg, onUndo, setMessages }) => {
  const toast = useRef(null);
  const hasShown = useRef(false);
  const prevMsgRef = useRef(successMsg);
  const toastLife = 60000;

  useEffect(() => {
    if (successMsg && toast.current && !hasShown.current) {
      hasShown.current = true;

      toast.current.show({
        severity: "error",
        detail: (
          <div className="flex align-items-center justify-content-between">
            <span className="p-message">{successMsg}</span>
            <a
              className="undo-link"
              onClick={(e) => {
                e.preventDefault();
                onUndo?.();
                toast.current.clear();
                hasShown.current = false;
              }}
            >
              Undo?
            </a>
          </div>
        ),
        icon: "pi pi-trash",
        life: toastLife,
        closable: true,
      });
      setTimeout(() => {
        hasShown.current = false;
        setMessages("");
      }, toastLife + 100);
    }

    // Only reset when transitioning from a message to no message
    if (!successMsg && prevMsgRef.current) {
      hasShown.current = false;
    }
    prevMsgRef.current = successMsg;
  }, [successMsg, onUndo]);

  return successMsg && <Toast ref={toast} position="bottom-right" />;
};

export default TemporaryNotification;
